export default "__VITE_ASSET__377cc67f__"